//
//
//
(function ($, window, document) {
	//
	//
	//
	$(function () {
		//
		//

		let alertPopup = $("#nu__alerts");
		if (alertPopup.length) {
			alertPopup.prepend(
				'<button class="toggle-alert"><i class="fa-regular fa-chevron-left"></i></button>'
			);
			alertPopup.addClass("is-open");
			if (localStorage.getItem("alert-dismissed")) {
				alertPopup.removeClass("is-open");
			}
			$(alertPopup).on("click", ".toggle-alert", function () {
				alertPopup.toggleClass("is-open");
				localStorage.setItem("alert-dismissed", true);
			});
		}

		//
	});
})(window.jQuery, window, document);
